module.exports = __webpack_public_path__ + "img/wrong.c7b00289.png";